import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class JsonDataService {

    constructor(private dataService: DataService) {
    };

    getAddressProof() {
        return this.dataService.getJsonData('./assets/json/staticdata/addressproof.json');
    }
    getorgList() {
        return this.dataService.getJsonData('./assets/json/staticdata/orglist.json');
    }
}
